// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"inventory_mainDiv__NV1zN","inventoryFormDiv":"inventory_inventoryFormDiv__2S3kZ","headingDiv":"inventory_headingDiv__1IasR"};